import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '10px 40px 0px'
  },
  cardWrapper: {
    margin: '10px 40px 24px',
  },
  swaggerWrapper: {
    margin: '0 40px',
    '& .swagger-ui': {
      '& .wrapper': {
        boxSizing: 'border-box',
        margin: '0 auto',
        maxWidth: '100%',
        padding: '0 20px',
        width: '100%'
      },
      '& .info': {
        display: 'none'
      }
    }
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subTitle: {
    fontSize: '16px',
    color: '#545455',
    marginTop: '10px'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',
    minWidth: '200px',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  failedWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
    backgroundColor: "#F5F5F5",
    textAlign: "center"
  },
  failedText: {
    fontWeight: 'bold',
    fontSize: '24px',
    color: '#335977'
  }
}))

export { useStyles }